import { Radio as MantineRadio } from '@mantine/core'
import { InputWrapper } from 'App/data-export/components/DataExport/InputWrapper'
import { dataExportStore } from 'App/data-export/store/dataExportStore'
import { Radio } from 'components/Radio/Radio'
import { translate } from 'i18n/i18n'

export const IntervalSelect = ({ options }: { options: Array<{ value: string; label: string }> }) => {
  const state = dataExportStore.useSelector((s) => s)

  return (
    <InputWrapper
      label={translate.phrases.banyanApp('Select Interval')}
      description={translate.phrases.banyanApp('Please select the time-interval')}
      error={!!state.formErrors.interval}
    >
      <MantineRadio.Group
        value={state.formState.interval || undefined}
        onChange={dataExportStore.actions.changeInterval}
      >
        <div css={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {options.map((option) => (
            <Radio size="md" key={option.value} label={option.label} value={option.value} />
          ))}
        </div>
      </MantineRadio.Group>
    </InputWrapper>
  )
}
